import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as featureFlagsSelectors from 'utils/featureFlags/selectors';
import { Config, BUILD_TYPE } from 'utils/webappConfig';
// import { isQuicken } from 'isAcme';
// import { getAuthSession } from 'utils/auth/utils';

const Cobrowse = () => {
  const featureFlagsError = useSelector(featureFlagsSelectors.getError);
  const featureFlagsLoadPending = useSelector(featureFlagsSelectors.getLoadPending);
  const cobrowse = useSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'cobrowse'));

  useEffect(() => {
    if (!featureFlagsLoadPending || featureFlagsError) {
      if (cobrowse) {
        if (window.CobrowseIO && window.CobrowseIO.start) {
          window.CobrowseIO.start();
        } else {
          /* eslint-disable */
          (function (w, t, c, p, s, e) {
            p = new Promise(function (r) {
              w[c] = {
                client: function () {
                  return p
                }
              };
              s = document.createElement(t);
              s.async = 1;
              s.src = 'https://js.cobrowse.io/CobrowseIO.js';
              e = document.getElementsByTagName(t)[0];
              e.parentNode.insertBefore(s, e);
              s.onload = function () {
                r(w[c]);
              };
            });
            return p;
          })(window, 'script', 'CobrowseIO').then(function () {
            try {
              window.CobrowseIO.license = Config.builds[BUILD_TYPE]?.cobrowse_license;
              window.CobrowseIO.start?.();
            } catch (e) {
              assert(false, e);
            }
          });
          /* eslint-enable */
        }
      } else if (window.CobrowseIO && window.CobrowseIO.stop) {
        window.CobrowseIO.stop();
      }
    }
  }, [featureFlagsLoadPending, featureFlagsError, cobrowse]);

  // const authSession = useSelector(getAuthSession);
  // useEffect(() => {
  //   if ((!featureFlagsLoadPending || featureFlagsError) && cobrowse && isQuicken && window.CobrowseIO) {
  //     window.CobrowseIO.customData = {
  //       user_name: "Joe Blogs",
  //       user_id: authSession.qcsId,
  //       user_email: "joe@example.com",
  //     }
  //   }
  // }, [authSession.qcsId, featureFlagsLoadPending, featureFlagsError, cobrowse]);

  return null;
};

export default Cobrowse;


